<template>
  <div class="base-avatar">
    <div
      class="base-avatar__container"
      :class="{ small: small, large: large, interactive: interactive }"
      :style="style"
    >
      <BaseIcon v-if="!name" name="user" class="base-avatar__user-icon" />
      <span v-else-if="!hasImage">{{ initials }}</span>
      <BaseBadge icon="check" v-if="hasCheckBadge" class="base-avatar__badge" />
    </div>
  </div>
</template>

<script>
import BaseIcon from '@/components/base/BaseIcon';
import BaseBadge from '@/components/base/BaseBadge';
import { getNameInitials } from '@/util/user-util';

export default {
  name: 'BaseAvatar',
  components: {
    BaseBadge,
    BaseIcon,
  },
  props: {
    name: {
      type: String,
      default: '',
    },
    imageUrl: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: '#fcdbd9',
    },
    small: {
      type: Boolean,
      default: false,
    },
    large: {
      type: Boolean,
      default: false,
    },
    interactive: {
      type: Boolean,
      default: false,
    },
    hasCheckBadge: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    initials() {
      return getNameInitials(this.name);
    },
    hasImage() {
      return this.imageUrl !== '';
    },
    style() {
      return {
        'background-color': this.hasImage ? 'none' : this.color,
        'background-image': this.hasImage ? 'url(' + this.imageUrl + ')' : 'none',
      };
    },
  },
};
</script>

<style lang="scss">
.base-avatar {
  &__badge {
    // z-index: 99; TO BE DETERMINED
    position: absolute;
    right: -4px;
    top: -4px;
  }

  &__container {
    align-items: center;
    background-repeat: no-repeat;
    background-position: center center;
    background-size: cover;
    color: $color-normal;
    display: flex;
    flex: none;
    justify-content: center;
    position: relative;
    font-family: $font-family-raleway;
    height: 32px;
    width: 32px;
    border-radius: $border-radius-round;
    font-size: 12px;

    &.small {
      height: 24px;
      width: 24px;
      border-radius: 24px;
      font-size: 10px;
      align-self: center;
    }

    &.large {
      height: 65px;
      width: 65px;
      border-radius: $border-radius-round;
      font-size: 14px;
      align-self: center;
    }

    &.interactive {
      cursor: pointer;
      height: 28px;
      width: 28px;
      box-shadow: $shadow-focus-outline !important;
      transition: all 200ms ease-in-out;
      outline: 2px solid $color-accent-300;

      &:hover {
        outline: 2px solid $color-accent;
        transition: all 200ms ease-in-out;
      }
    }

    @media screen and (max-width: 468px) {
      &.large {
        height: 45px;
        width: 45px;
        margin-right: 15px;
      }
    }
  }

  &__user-icon {
    width: 14px;
    height: 14px;
  }
}
</style>
